/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  Tabs,
  Card,
  message,
  Col,
  Input,
  // Button,
  DatePicker,
} from 'antd';
import {
  CheckCircleOutlined,
  MinusCircleOutlined,
  // SearchOutlined,
  StopOutlined,
} from '@ant-design/icons';
import {
  formatReceived,
  // formatReceivedValues,
} from 'utils/formatValues';
// import { areaBuscar, normalizeData } from 'utils/normalizers';
import { onError } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
// import CustomSearch from 'components/customSearch';
import { checkToken } from 'api/utils';
import TabPane from 'antd/lib/tabs/TabPane';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import makeMessager from 'utils/complexFormsMessages';
import { getModelPermission } from 'utils/permission';
import {
  getSuspensionDePago,
  getSuspensionesDePagos,
  patchSuspensionDePago,
  postSuspensionDePago,
  putSuspensionesDePagos,
  putLiberacionesDePagos,
  putBajasDePagos,
  deleteSuspensionesDePagos,
} from 'api/nominas/suspensiones/suspensionDePagos';
import {
  getEmpleado,
  // getEmpleadosConDatosOpFilteredPaginated,
  getEmpleadosFiltered,
} from 'api/estructuraOrganizacional/empleados';
import { getMotivosDeSuspensionesDePagos } from 'api/nominas/suspensiones/motivosDeSuspensionesDePagos';
import { getTiposDeSuspensionesDePagos } from 'api/nominas/suspensiones/tiposDeSuspensionesDePagos';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
// import { getAreas, getTiposDeEmpleados } from 'api/catalogos';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
// import { getPuestos } from 'api/catalogos/puestos';
import { getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getEstadosDeSuspensionesDePagos } from 'api/nominas/suspensiones/estadosDeSuspensiones';
// import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import Select from 'components/Select';
import PercentageInput from 'components/PercentageInput';
import ModalFechaObservacion from 'components/ModalFechaObservacion';
import ModalConfirmation from 'components/ModalConfirmation';
import {
  ESTADO_PAGO_SUSPENDIDO,
  ESTADO_PAGO_LIBERADA,
  BAJA_DE_EMPLEADO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import percentFormatter from 'utils/percentFormatter';
import SuspensionDePagosDatosInformativos, { suspensionDatosPermission } from './SuspensionDePagosDatosInformativos';

export const suspensionDePagosPermission = {
  permissionModel: 'suspensiondepagoempleado',
  catalogsModels: [],
  tabsModels: [],
};

export const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        setCurrentTabKey(formWithErrors.tabKey);
      }
    });
  }
};

const SuspensionDePagos = ({ permission }) => {
  const [form] = Form.useForm();
  const [formModal] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [mutable, setMutable] = useState(true);
  const [open, setVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openSuspender, setOpenSuspender] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);

  const [datosOperacionales, setDatosOperacionales] = useState([]);
  // const [tiposEmpleados, setTiposEmpleados] = useState([]);
  // const [puestos, setPuestos] = useState([]);
  // const [adminPlazas, setAdminPlazas] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [motivosSuspension, setMotivosSuspension] = useState([]);
  const [tiposSuspensiones, setTiposSuspensiones] = useState([]);
  const [periodosNominas, setPeriodosNominas] = useState([]);
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  // const [areas, setAreas] = useState([]);
  const [estatus, setEstatus] = useState([]);
  const [data, setData] = useState([]);
  const [suspensionId, setSuspensionId] = useState();
  const [periodosDetallesFiltered, setPeriodosDetallesFiltered] = useState([]);
  const [disableFields, setDisableFields] = useState(false);
  const [estatusFiltered, setEstatusFiltered] = useState([]);
  const [disableEstatus, setDisableEstatus] = useState(true);

  const [empleadosFiltered, setEmpleadosFiltered] = useState([]);
  const [disablePorcentaje, setDisablePorcentaje] = useState(true);
  const [claveNombreEmpleado, setClaveNombreEmpleado] = useState('');
  const [title, setTitle] = useState('');
  const [liberadoBaja, setLiberadoBaja] = useState();
  const [canSuspender, setCanSuspender] = useState(false);
  const [canLibBajar, setCanLibBajar] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);
  const [disableDelete, setDisableDelete] = useState(false);
  // const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  // const [openSearch, setVisibleSearch] = useState(false);
  // const [dataSearch, setDataSearch] = useState([]);
  // const [baseURIPagination, setBaseURIPagination] = useState();
  // const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();

  // let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  // const formatReceivedClone = (values) => {
  //   if (Array.isArray(values)) {
  //     let valueClone = values.map((e) => formatReceivedValues(e));
  //     valueClone = valueClone.map((e) => ({
  //       ...e,
  //       nombreEmpleado: e?.empleado,
  //       tipoEmpleado: e?.empleado,
  //       puestoEmpleado: e?.empleado,
  //       areaEmpleado: e?.empleado,
  //       plazaEmpleado: e?.empleado,
  //     }));
  //     return valueClone;
  //   }
  //   return formatReceivedValues(values);
  // };

  const nameEmpleado = 'empleado';
  const nameTipoEmpleado = 'tipo_empleado';
  const namePuesto = 'puesto';
  const nameArea = 'area';
  const namePlaza = 'plaza';

  const getPlaza = (idEmpleado) => {
    const _datoOperacional = datosOperacionales?.find((e) => e.empleado === idEmpleado);
    const idPlaza = _datoOperacional?.plaza;
    return ({
      _plaza: plazas?.find((p) => p.id === idPlaza),
      _datoOp: _datoOperacional,
    });
  };
  const watcherEmpleado = Form.useWatch(nameEmpleado, form);
  useEffect(() => {
    if (!watcherEmpleado) { return; }
    const { _plaza, _datoOp } = getPlaza(watcherEmpleado);

    const areaStr = _plaza?.directorio_area_clave_y_nombre || '';
    const plazaStr = _plaza?.clave_y_descripcion || '';
    const puestoStr = _plaza?.puesto_clave_y_descripcion || '';
    const tipoNomina = _plaza?.tipo_nomina_empleado || '';
    const fieldsValues = {
      [namePlaza]: plazaStr,
      [namePuesto]: puestoStr,
      [nameArea]: areaStr,
      [nameTipoEmpleado]: tipoNomina,
    };
    const _periodos = periodosNominas?.find((e) => e?.tipo_de_nomina_empleado === _datoOp?.tipo_de_nomina_empleado);
    const _periodosDetallesFiltered = periodosNominasDetalles?.filter((e) => e?.periodo_de_nomina === _periodos?.id);

    form.setFieldsValue(fieldsValues);
    setPeriodosDetallesFiltered(_periodosDetallesFiltered);
  }, [watcherEmpleado]);

  const getPermission = getModelPermission(
    suspensionDatosPermission.permissionModel,
    suspensionDatosPermission.catalogsModels,
    suspensionDatosPermission.tabsModels,
    false,
  );

  const requiredFormStructure = [
    {
      parentTabKey: 'general',
      tabKey: 'general',
    },
    {
      parentTabKey: 'datos_informativos',
      tabKey: 'datos_informativos',
    },
  ];

  const basicKeys = [
    'general',
    'datos_informativos',
  ];

  const complexForms = [];

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getSuspensionesDePagos();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    const selectedData = data.filter((item) => selectedRowKeys.includes(item.id));
    const estadosSuspension = selectedData.map((item) => item.estado_suspension);

    const activos = estadosSuspension.every((estado) => estado === 1);
    const suspendidos = estadosSuspension.every((estado) => estado === 2);

    const validacionSuspender = activos;
    const validacionLiberarBajar = suspendidos;

    if (estadosSuspension.length === 0) {
      setCanSuspender(false);
      setCanLibBajar(false);
      setDisableEdit(false);
      setDisableDelete(false);
    } else {
      setCanSuspender(validacionSuspender);
      setCanLibBajar(validacionLiberarBajar);
      setDisableEdit(estadosSuspension.includes(3) || estadosSuspension.includes(4));
      setDisableDelete(estadosSuspension.includes(3) || estadosSuspension.includes(4));
    }
  }, [selectedRowKeys]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      try {
        setLoading(true);
        await checkToken();
        const [
          _empleados,
          _datosOperacionales,
          // _tiposEmpleados,
          // _puestos,
          _adminPlazas,
          _plazas,
          _motivosSuspensiones,
          _tiposSuspensiones,
          _periodosNominas,
          _periodosNominasDetalles,
          // _areas,
          _estatus,
          // _tipos_de_nominas_empleados,
          _data,
        ] = await Promise.all([
          getEmpleadosFiltered(),
          getDatoOperacionalesDeEmpleados(),
          // getTiposDeEmpleados(),
          // getPuestos(),
          getAdministracionDePlazasvistaOptimized(),
          getPlazasvistaOptimized(),
          getMotivosDeSuspensionesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeSuspensionesDePagos(),
          getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
          getPeriodosDeNominasDetalles(),
          // getAreas(),
          getEstadosDeSuspensionesDePagos(),
          // getTiposDeNominasEmpleados(),
          getSuspensionesDePagos(),
        ]);

        if (mounted) {
          // const formattedURS = normalizeData(_areas);
          setDatosOperacionales(_datosOperacionales);
          // setTiposEmpleados(_tiposEmpleados);
          // setPuestos(_puestos);
          // setAdminPlazas(_adminPlazas);
          setPlazas(_plazas);
          setMotivosSuspension(_motivosSuspensiones);
          setTiposSuspensiones(_tiposSuspensiones);
          setPeriodosNominas(_periodosNominas);
          setPeriodosNominasDetalles(_periodosNominasDetalles.filter((periodosNomDetalle) => _periodosNominas.some((periodoNomina) => periodoNomina.id === periodosNomDetalle?.periodo_de_nomina)));
          // setAreas(formattedURS);
          setEstatus(_estatus);
          // setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
          setData(formatReceived(_data));
          setEstatusFiltered(_estatus);
          const _empleadosFiltered = _empleados.filter((e) => _adminPlazas?.some((x) => x.empleado_id === e?.id));
          setEmpleadosFiltered(_empleadosFiltered);
          setLoading(false);
        }
      } catch (error) {
        if (mounted) {
          setLoading(false); // <-- ESTO EVITA EL SPINNER INFINITO
          // Opcionalmente puedes mostrar la alerta usando tu manejador
          // onError(error, setLoading);
        }
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setEstatusFiltered(estatus);
    setSelectedRowKeys([]);
    setVisible(false);
    // setVisibleSearch(false);
    // setSelectedEmpleadoSearch();
    setMutable(true);
    setSuspensionId();
    setDisableFields(false);
    setDisablePorcentaje(true);
    setCurrentTabKey('general');
    setVisibleAlert(false);
    setOpenModal(false);
    setTitle('');
    setOpenSuspender(false);
    setLiberadoBaja();
    form.resetFields();
    formModal.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    setSuspensionId(match.id);
    const _suspensionDePago = await getSuspensionDePago(match.id);
    const _empleadoId = _suspensionDePago?.empleado;
    const _empleado = await getEmpleado(_empleadoId);
    // setSelectedEmpleadoSearch(_empleado);
    // const _datosOperacionales = datosOperacionales.find((e) => e.empleado === _empleadoId);
    // const _adminPlaza = adminPlazas.find((e) => e.empleado === _empleadoId);
    // const _plaza = plazas.find((e) => e.id === _adminPlaza?.plaza);
    // const _puesto = puestos.find((e) => e.id === _plaza?.puesto);
    // const _tipoEmpleado = tiposEmpleados.find((e) => e.id === _puesto?.tipo_empleado);
    // const _area = areaBuscar(_plaza?.area_content_id, areas)?.title;
    const _estatusFiltered = estatus.filter((e) => e.id === 2 || e.id === 3 || e.id === 4);
    setTimeout(() => {
      if (_suspensionDePago) {
        form.resetFields();
        if (_suspensionDePago?.estado_suspension !== 1) {
          setDisableFields(true);
          if (_suspensionDePago?.estado_suspension === 2) {
            setDisableEstatus(false);
          } else {
            setDisableEstatus(true);
          }
          setEstatusFiltered(_estatusFiltered);
        } else {
          setDisableFields(false);
          setDisableEstatus(true);
          setEstatusFiltered(estatus);
        }
        _suspensionDePago?.aplica_pago_de_nomina ? setDisablePorcentaje(false) : setDisablePorcentaje(true);
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_suspensionDePago));
          form.setFieldsValue({
            [nameEmpleado]: _empleado?.id,
            // empleado: `${_empleado?.numero_de_empleado || ''} - ${_empleado?.nombre || ''} ${_empleado?.apellido_paterno || ''} ${_empleado?.apellido_materno || ''}`,
            // tipo_empleado: _tipoEmpleado?.descripcion,
            // puesto: _puesto?.descripcion,
            // area: _area,
            // plaza: _plaza?.clave,
          });
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
        // empleado: selectedEmpleadoSearch?.id,
      };
      const [key] = selectedRowKeys;
      const saved = await (key ? patchSuspensionDePago(key, values) : postSuspensionDePago(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          setSuspensionId(saved.id);
          await onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      if (err.errorFields) {
        onErrorFields(
          err,
          setLoading,
          requiredFormStructure,
          setCurrentTabKey,
        );
        message.warn('Favor de corregir los errores señalados');
      } else {
        onError(
          err,
          setLoading,
          formInstances,
        );
      }
    }
  };

  const onClickModal = async () => {
    setOpenModal(true);
  };

  const onClickSuspender = async () => {
    setOpenSuspender(true);
  };

  const onSuspender = async () => {
    try {
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val, estado_retencion: ESTADO_PAGO_SUSPENDIDO,
      }));
      const saved = await putSuspensionesDePagos(mappedSelectedRowKeys);
      if (saved) {
        onCancel();
        await fetchData();
      }
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const onLiberarCancelar = async () => {
    try {
      await formModal.validateFields();
      const value = {
        ...formModal.getFieldsValue(),
      };
      let mappedSelectedRowKeys;
      if (liberadoBaja) {
        mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
          // eslint-disable-next-line
          id: val, estado_retencion: ESTADO_PAGO_LIBERADA, fecha: value.fecha_liberacion_cancelacion, observaciones: value.observaciones,
        }));
        const saved = await putLiberacionesDePagos(mappedSelectedRowKeys);
        if (saved) {
          onCancel();
          await fetchData();
          formModal.resetFields();
        }
      } else {
        mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
          // eslint-disable-next-line
          id: val, estado_retencion: BAJA_DE_EMPLEADO, fecha: value.fecha_liberacion_cancelacion, observaciones: value.observaciones,
        }));
        const saved = await putBajasDePagos(mappedSelectedRowKeys);
        if (saved) {
          onCancel();
          await fetchData();
          formModal.resetFields();
        }
      }
    } catch (err) {
      onError(
        err,
        formInstances,
      );
    }
  };

  const deleteMultipleRows = async () => {
    try {
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val,
      }));
      const saved = await deleteSuspensionesDePagos(mappedSelectedRowKeys);
      if (saved) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((id) => id !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }

    if (selectedRowKeys.length < 1) {
      const {
        numero_de_empleado,
        nombre,
        apellido_paterno,
        apellido_materno,
      } = empleadosFiltered.find((empleado) => empleado.id === record.empleado);

      setClaveNombreEmpleado(`${numero_de_empleado} - ${nombre} ${apellido_paterno} ${apellido_materno || ''}`.toUpperCase());
      setSelectedRowKeys([record.id]);
      form.setFieldsValue(record);
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: 'checkbox',
  };

  const onClickAdd = () => {
    onCancel();
    setCurrentTabKey('general');
    setSelectedRowKeys([]);
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const showMsg = makeMessager(setCurrentTabKey);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  // const onChangeEmpleado = (val) => {
  //   form.resetFields([
  //     'tipo_empleado',
  //     'puesto',
  //     'area',
  //     'plaza',
  //     'periodo_de_nomina_detalle_inicial',
  //     'periodo_de_nomina_detalle_final',
  //   ]);
  //   if (val) {
  //     const _datosOperacionales = datosOperacionales.find((e) => e.empleado === val);
  //     const _adminPlaza = adminPlazas.find((e) => e.empleado === val);
  //     const _plaza = plazas.find((e) => e.id === _adminPlaza?.plaza);
  //     const _puesto = puestos.find((e) => e.id === _plaza?.puesto);
  //     const _tipoEmpleado = tiposEmpleados.find((e) => e.id === _puesto?.tipo_empleado);
  //     const _area = areaBuscar(_plaza?.area_content_id, areas)?.title;
  //     const _periodos = periodosNominas.find((e) => e.tipo_de_nomina_empleado === _datosOperacionales?.tipo_de_nomina_empleado);
  //     const _periodosDetallesFiltered = periodosNominasDetalles.filter((e) => e.periodo_de_nomina === _periodos?.id);
  //     setPeriodosDetallesFiltered(_periodosDetallesFiltered);
  //     form.setFieldsValue({
  //       tipo_empleado: _tipoEmpleado?.descripcion,
  //       puesto: _puesto?.descripcion,
  //       area: _area,
  //       plaza: _plaza?.clave,
  //     });
  //   }
  // };

  // const validateInput = async () => {
  //   setLoading(true);
  //   setSelectedEmpleadoSearch();
  //   const searchEmp = form.getFieldValue('empleado');
  //   if (!searchEmp) {
  //     setVisibleSearch(true);
  //     return setLoading(false);
  //   }
  //   const res = await getEmpleadosConDatosOpFilteredPaginated(`${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`);
  //   const result = res?.results[0];
  //   if (!res) {
  //     return setLoading(false);
  //   }
  //   const empleadoResult = result?.empleado;
  //   setSelectedEmpleadoSearch(empleadoResult);
  //   if (empleadoResult) {
  //     form.setFieldsValue({
  //       empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
  //     });
  //   } else {
  //     form.resetFields(['empleado']);
  //   }
  //   onChangeEmpleado(empleadoResult?.id);
  //   return setLoading(false);
  // };

  // const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
  //   setLoading(true);
  //   if (empId) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
  //   }
  //   if (nombreEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
  //   }
  //   if (apPatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
  //   }
  //   if (apMatEmp) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
  //   }
  //   if (tipoNominaEmpleado) {
  //     baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
  //   }
  //   setBaseURIPagination(baseURIDatosOpPaginado);
  //   const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
  //   setDataSearch(_empleados);
  //   return setLoading(false);
  // };

  // const columnsEmpleado = [
  //   {
  //     titleText: 'No. de Empleado',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 200,
  //     render: (empObject) => empObject?.numero_de_empleado,
  //   },
  //   {
  //     titleText: 'Nombre',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.nombre,
  //   },
  //   {
  //     titleText: 'Apellido Paterno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_paterno,
  //   },
  //   {
  //     titleText: 'Apellido Materno',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 250,
  //     render: (empObject) => empObject?.apellido_materno,
  //   },
  //   {
  //     titleText: 'Puesto',
  //     dataIndex: 'empleado',
  //     key: 'empleado',
  //     width: 300,
  //     render: (empObject) => {
  //       const adminPlazaEmp = adminPlazas?.find((admP) => admP?.empleado === empObject?.id);
  //       const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
  //       const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
  //       return `${puestoEmp?.descripcion || ''}`;
  //     },
  //   },
  //   {
  //     titleText: 'Tipo de Nómina Empleado',
  //     dataIndex: 'tipo_de_nomina_empleado',
  //     key: 'tipo_de_nomina_empleado',
  //     width: 250,
  //     render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
  //   },
  // ];

  const columns = [
    {
      titleText: 'No. y Nombre de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (val) => empleadosFiltered?.find((e) => e.id === val)?.numero_y_nombre_completo,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (val) => {
        const { _plaza } = getPlaza(val);
        return _plaza?.tipo_nomina_empleado;
      },
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (val) => {
        const { _plaza } = getPlaza(val);
        return _plaza?.puesto_clave_y_descripcion;
      },
    },
    {
      titleText: 'Área',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (val) => {
        const { _plaza } = getPlaza(val);
        return _plaza?.directorio_area_clave_y_nombre;
      },
    },
    {
      titleText: 'Plaza',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (val) => {
        const { _plaza } = getPlaza(val);
        return _plaza?.clave_y_descripcion;
      },
    },
    {
      titleText: 'Motivo de Suspensión de Pago',
      dataIndex: 'motivo_de_suspension_de_pago',
      key: 'motivo_de_suspension_de_pago',
      width: 250,
      render: (val) => motivosSuspension.find((e) => e.id === val)?.motivo,
    },
    {
      titleText: 'Tipo de Suspensión de Pago',
      dataIndex: 'tipo_de_suspension_de_pago',
      key: 'tipo_de_suspension_de_pago',
      width: 250,
      render: (val) => tiposSuspensiones.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: '% de Pago',
      dataIndex: 'porcentaje_de_pago',
      key: 'porcentaje_de_pago',
      width: 200,
      render: (val) => percentFormatter(val || 0),
    },
    {
      titleText: 'Periodo Inicial de Nómina',
      dataIndex: 'periodo_de_nomina_detalle_inicial',
      key: 'periodo_de_nomina_detalle_inicial',
      width: 250,
      render: (val) => {
        const _periodo = periodosNominasDetalles.find((e) => e.id === val);
        return `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial} - ${_periodo?.fecha_inicial})`;
      },
    },
    {
      titleText: 'Periodo Final de Nómina',
      dataIndex: 'periodo_de_nomina_detalle_final',
      key: 'periodo_de_nomina_detalle_final',
      width: 250,
      render: (val) => {
        const _periodo = periodosNominasDetalles.find((e) => e.id === val);
        return `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial} - ${_periodo?.fecha_inicial})`;
      },
    },
    {
      titleText: 'Fecha de Liberación o Baja',
      dataIndex: 'fecha_liberacion_cancelacion',
      key: 'fecha_liberacion_cancelacion',
      width: 220,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 300,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_suspension',
      key: 'estado_suspension',
      width: 200,
      render: (val) => estatus.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    porcentaje: [
      { required: true },
      {
        validator: async (rule, value) => {
          if (value > 100) {
            throw new Error('El porcentaje no puede ser mayor a 100%');
          }
        },
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => onClickSuspender(),
                text: 'Suspender',
                icon: <StopOutlined />,
                disabled: !canSuspender,
              },
              {
                onClick: () => onClickModal(setTitle(' Liberación'), setLiberadoBaja(true)),
                text: 'Liberar',
                icon: <CheckCircleOutlined />,
                disabled: !canLibBajar,
              },
              {
                onClick: () => onClickModal(setTitle(' Baja'), setLiberadoBaja(false)),
                text: 'Baja',
                icon: <MinusCircleOutlined />,
                disabled: !canLibBajar,
              },
            ]}
            permission={permission}
            allowExportPDF={false}
            disableDelete={disableDelete}
            allowDoubleClick={false}
          />
        ) : (
          <Card
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Suspensión de Pago`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!disableEdit}
              />
            )}
            className="form-container"
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstErrors
              name="general"
              dsable={disableEdit}
              style={{ overflowY: 'hidden' }}
            >
              <Tabs
                activeKey={currentTabKey}
                onChange={mutable ? onChangeTabKey : setCurrentTabKey}
                type="card"
              >
                <TabPane
                  tab="General"
                  key="general"
                  forceRender
                >
                  <Form
                    layout="vertical"
                    form={form}
                    scrollToFirstError
                    name="general"
                  >
                    <Row gutter={10}>

                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={nameEmpleado}
                          label="No. y Nombre del Empleado"
                          required
                          hasFeedback
                        >
                          <Select
                            labelProp="numero_y_nombre_completo"
                            dataSource={empleadosFiltered}
                            disabled={selectedRowKeys?.length}
                          />
                        </Form.Item>
                      </Col>
                      {/* <Col xs={24} sm={24} md={8}>
                        <Row align="middle">
                          <Col xs={24} sm={24} md={24}>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                              <Form.Item
                                label="No. y Nombre del Empleado"
                                name="empleado"
                                hasFeedback
                              >
                                <Input
                                  allowClear
                                />
                              </Form.Item>
                              <Button
                                loading={loading}
                                onClick={validateInput}
                                icon={<SearchOutlined />}
                                style={{
                                  width: '2.7rem',
                                  marginTop: '-2px',
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col> */}
                      {/* }{selectedEmpleadoSearch
                        ? (
                          form.setFieldsValue({
                            empleado: `${selectedEmpleadoSearch?.numero_de_empleado || ''} - ${selectedEmpleadoSearch?.nombre || ''} ${selectedEmpleadoSearch?.apellido_paterno || ''} ${selectedEmpleadoSearch?.apellido_materno || ''}`,
                          })
                        ) : null} */}
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={nameTipoEmpleado}
                          label="Tipo de Empleado"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={namePuesto}
                          label="Puesto"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={nameArea}
                          label="Área"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={namePlaza}
                          label="No. de Plaza"
                        >
                          <Input
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="motivo_de_suspension_de_pago"
                          label="Motivo de Suspensión"
                          rules={rules.required}
                        >
                          <Select
                            dataSource={motivosSuspension}
                            keyProp="id"
                            labelProp="motivo"
                            disabled={disableFields}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_de_suspension_de_pago"
                          label="Tipo de Suspensión"
                          rules={rules.required}
                        >
                          <Select
                            dataSource={tiposSuspensiones}
                            disabled={disableFields}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_pago_de_nomina"
                          label="Aplica Pago de Nómina"
                          rules={rules.required}
                        >
                          <Select
                            trueFalse
                            disabled={disableFields}
                            onChange={(value) => {
                              form.setFieldValue('porcentaje_de_pago', 0);
                              value ? setDisablePorcentaje(false) : setDisablePorcentaje(true);
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="porcentaje_de_pago"
                          label="Porcentaje de Pago"
                          rules={!disablePorcentaje && rules.porcentaje}
                        >
                          <PercentageInput
                            disabled={disablePorcentaje || disableFields}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="periodo_de_nomina_detalle_inicial"
                          label="Periodo Inicial de Nómina"
                          rules={rules.required}
                        >
                          <Select
                            dataSource={periodosDetallesFiltered}
                            render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
                            disabled={disableFields}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="periodo_de_nomina_detalle_final"
                          label="Periodo Final de Nómina"
                          rules={rules.required}
                        >
                          <Select
                            dataSource={periodosDetallesFiltered}
                            render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
                            disabled={disableFields}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fecha_liberacion_cancelacion"
                          label="Fecha de Liberación o Baja"
                          hasFeedback
                        >
                          <DatePicker
                            allowClear
                            format="DD/MM/YYYY"
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row
                      gutter={10}
                      style={{ paddingBottom: '.1rem' }}
                    >
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="estado_suspension"
                          label="Estatus"
                          initialValue={1}
                        >
                          <Select
                            dataSource={estatusFiltered}
                            disabled={disableEstatus}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
                <TabPane
                  tab="Datos Informativos"
                  key="datos_informativos"
                  forceRender
                  disabled={!selectedRowKeys.length}
                >
                  <SuspensionDePagosDatosInformativos
                    suspensionId={suspensionId}
                    rules={rules}
                    permission={getPermission}
                  />
                </TabPane>
              </Tabs>
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteMultipleRows}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={selectedRowKeys.length === 1 ? `Suspensión De Pago ${claveNombreEmpleado}` : `${selectedRowKeys.length} Suspensión De Pago?`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onSuspender}
          onCancel={onCancel}
          contentTitle={selectedRowKeys.length === 1 ? 'Suspender el Registro Seleccionado' : `Suspender ${selectedRowKeys.length} Registros Seleccionados`}
          open={openSuspender}
          ConfirmSuspension
        />
        <ModalFechaObservacion
          open={openModal}
          onCancel={onCancel}
          onPutDate={onLiberarCancelar}
          title={title}
          subTitle={title}
          form={formModal}
          fechaKey="fecha_liberacion_cancelacion"
        />
        {/* <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleadoSearch}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={onChangeEmpleado}
        /> */}
      </Spin>
    </Row>
  );
};

export default SuspensionDePagos;
